import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-4 px-6"
}
const _hoisted_2 = { class: "mb-4 text-4xl" }
const _hoisted_3 = { class: "my-4 text-xl" }
const _hoisted_4 = { class: "my-4 text-sm" }
const _hoisted_5 = { class: "my-4 text-xl capitalize" }
const _hoisted_6 = { class: "my-4 text-xl capitalize" }
const _hoisted_7 = { class: "my-4 text-xl" }
const _hoisted_8 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Prerequisites: ")
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center h-full text-xl"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_syllabus_event_maneuver_table = _resolveComponent("syllabus-event-maneuver-table")

  return (_ctx.event)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, _toDisplayString(_ctx.event.name), 1),
        _createVNode("div", _hoisted_3, _toDisplayString(_ctx.event.title), 1),
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.event.objectives), 1),
        _createVNode("div", _hoisted_5, " Category: " + _toDisplayString(_ctx.formatCategory(_ctx.event.category)), 1),
        _createVNode("div", _hoisted_6, " Phase: " + _toDisplayString(_ctx.formatPhase(_ctx.event.phase)), 1),
        _createVNode("div", _hoisted_7, "Hours: " + _toDisplayString(_ctx.event.hours), 1),
        (_ctx.event.prerequisites && _ctx.event.prerequisites.length)
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.event.prerequisites, (prerequisite, index) => {
                return (_openBlock(), _createBlock("div", {
                  class: "inline p-2 mr-2",
                  key: index
                }, _toDisplayString(prerequisite), 1))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.maneuvers.length)
          ? (_openBlock(), _createBlock(_component_syllabus_event_maneuver_table, {
              key: 1,
              class: "mb-16",
              maneuvers: _ctx.maneuvers
            }, null, 8, ["maneuvers"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock("div", _hoisted_10, " No event found with name " + _toDisplayString(_ctx.route.params.name), 1))
}